import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { createMarkup } from '../../helpers';
import Label from '../../components/Label';
import Page from '../../components/Page';
import s from './StaticPage.scss';

const StaticPage = ({ page }) => (
  <Page>
    <div className={s.top}>
      <Label bold tag="h1" className={s.title}>
        {page.pageHeader}
      </Label>
    </div>
    <div
      className={s.content}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={createMarkup(page.pageBody)}
    />
  </Page>
);

StaticPage.propTypes = {
  page: PropTypes.shape().isRequired,
};

export default withStyles(s)(StaticPage);
